// src/store/features/location/locationSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCountries, fetchStates, fetchCities } from "./locationApi";

export const getCountries = createAsyncThunk(
  "location/getCountries",
  fetchCountries
);
export const getStates = createAsyncThunk("location/getStates", fetchStates);
export const getCities = createAsyncThunk(
  "location/getCities",
  async ({ countryCode, stateCode }) => {
    const response = await fetchCities(countryCode, stateCode);
    return response;
  }
);

const locationSlice = createSlice({
  name: "location",
  initialState: {
    countries: [],
    states: [],
    cities: [],
    loading: false,
  },
  reducers: {
    resetLocation: (state) => {
      state.states = [];
      state.cities = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCountries.fulfilled, (state, action) => {
        state.countries = action.payload;
      })
      .addCase(getStates.fulfilled, (state, action) => {
        state.states = action.payload;
      })
      .addCase(getCities.fulfilled, (state, action) => {
        state.cities = action.payload;
      });
  },
});

export const { resetLocation } = locationSlice.actions;
export default locationSlice.reducer;
